import Emitter from '@resources/js/helpers/Emitter'
import NiceSelect from 'nice-select2'

const GUEST_TYPES = {
	adults: 'adults',
	children: 'children',
}

export default class Guests extends Emitter {
	#containerElement
	#adultsElement
	#childrenElement
	#adultsValueElement
	#childrenValueElement
	#childrenAgesWrapElement
	#childrenObjectsArray // масив обєктів {node, niceSelectInstance, selectElement, index, changeHandler}
	#guestCountsObj

	constructor(containerElement) {
		super()

		this.#containerElement = containerElement

		if (!this.#containerElement)
			throw new Error('Guests container element is not found!')

		this.#adultsElement =
			this.#containerElement.querySelector('.js-guests-adults')
		this.#childrenElement =
			this.#containerElement.querySelector('.js-guests-children')
		this.#adultsValueElement =
			this.#adultsElement.querySelector('.js-guests-value')
		this.#childrenValueElement =
			this.#childrenElement.querySelector('.js-guests-value')
		this.#childrenAgesWrapElement =
			this.#containerElement.querySelector('.js-children-ages')

		this.#childrenObjectsArray = []

		this.#guestCountsObj = {
			adults: 2,
			children: 0,
		}

		this.#init()
	}

	#init() {
		this.#initControls(this.#adultsElement, GUEST_TYPES.adults)
		this.#initControls(this.#childrenElement, GUEST_TYPES.children)
	}

	#initControls(element, type) {
		const plusBtnElement = element.querySelector('.js-guests-btn-plus')
		const minusBtnElement = element.querySelector('.js-guests-btn-minus')

		plusBtnElement.addEventListener('click', () => {
			const value = this.#guestCountsObj[type] + 1
			this.#emitChange(type, value)
		})

		minusBtnElement.addEventListener('click', () => {
			const value = this.#guestCountsObj[type] - 1
			this.#emitChange(type, value)
		})
	}

	#emitChange(type, value) {
		this.emit(`${type}-change`, value)
	}

	setAdultsCount(value) {
		this.#adultsValueElement.textContent = value

		this.#guestCountsObj.adults = value

		this.#emitGuestsCountChange()
	}

	setChildrenCount(value) {
		this.#childrenValueElement.textContent = value

		this.#guestCountsObj.children = value

		this.#emitGuestsCountChange()
	}

	#emitGuestsCountChange() {
		this.emit('guests-count-change', this.#guestCountsObj)
	}

	#createChildAgeSelect(index) {
		const template = this.#containerElement.querySelector('#child-age-template')
		const node = template.content.firstElementChild.cloneNode(true)

		const selectElement = node.querySelector('.js-child-age-select')
		selectElement.setAttribute('name', `child-${index}`)

		const niceSelectInstance = new NiceSelect(selectElement, {
			searchable: false,
		})

		const changeHandler = event => {
			this.#handleChildAgeChange(index, event.target.value)
		}

		selectElement.addEventListener('change', changeHandler)

		this.#childrenObjectsArray.push({
			node,
			niceSelectInstance,
			selectElement,
			index,
			changeHandler,
		})

		return node
	}

	#destroyChildAgeSelect(childObj) {
		childObj.selectElement.removeEventListener('change', childObj.changeHandler)
		childObj.niceSelectInstance.destroy()
		childObj.node.remove()
	}

	#handleChildAgeChange(index, value) {
		this.emit('child-age-change', { index, value })
	}

	updateChildAgeSelects(count) {
		const currentCount = this.#childrenObjectsArray.length

		if (count < currentCount) this.#removeChildAgeSelects(count)
		if (count > currentCount) this.#addChildAgeSelects(count)
	}

	#addChildAgeSelects(count) {
		for (let i = this.#childrenObjectsArray.length; i < count; i++) {
			const select = this.#createChildAgeSelect(i)

			this.#childrenAgesWrapElement.append(select)
		}
	}

	#removeChildAgeSelects(count) {
		const elementsToRemove = this.#childrenObjectsArray.slice(count)

		elementsToRemove.forEach(childObj => this.#destroyChildAgeSelect(childObj))

		this.#childrenObjectsArray = this.#childrenObjectsArray.slice(0, count)
	}

	setChildAge(index, value) {
		const childObj = this.#childrenObjectsArray.find(obj => obj.index === index)
		if (!childObj) return

		// update() перестворює дропдаун і закриває дропдаун гостей,
		// тому викликаємо його лише якщо значення змінилось (не при виборі юзером)
		if (childObj.selectElement.value === String(value)) return

		childObj.selectElement.value = value
		childObj.niceSelectInstance.update()
	}
}
